import highlightsWebp from '@/pages/hcp/components/hero-carousel/images/hero-carousel__bg-highlights.webp';
import highlightsMobileWebp from '@/pages/hcp/components/hero-carousel/images/hero-carousel__bg-highlights-mobile.webp';
import bgWebp from '@/pages/hcp/components/hero-carousel/images/bg-texture-dark.webp';
import pillBottleWebp from "@/pages/hcp/components/hero-carousel/images/pill-bottle-graphic.webp";
import scaleWebp from "@/pages/hcp/components/hero-carousel/images/balancing-scales-graphic.webp";
import trafficSignWebp from "@/pages/hcp/components/hero-carousel/images/two-way-road-sign-graphic.webp";

const hcpPageData = [
  {
    name: 'hcp',
    path: '/hcp',
    title: 'Home | What The C@H? | HCP Site',
    headerNavigationLabel: <>HOME</>,
    sitemapNavigationLabel: <>Home</>,
    groupId: 0,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about congenital adrenal hyperplasia, the science behind CAH, managing excess androgens, treating CAH, and research.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Home | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about congenital adrenal hyperplasia, the science behind CAH, managing excess androgens, treating CAH, and research.',
      }, {
        name: 'twitter:title',
        content: 'Home | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about congenital adrenal hyperplasia, the science behind CAH, managing excess androgens, treating CAH, and research.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp',
      }, {
        rel: 'preload',
        as: 'image',
        href: bgWebp,
        fetchpriority: 'high',
      }, {
        rel: 'preload',
        as: 'image',
        href: highlightsWebp,
        fetchpriority: 'high',
      }, {
        rel: 'preload',
        as: 'image',
        href: highlightsMobileWebp,
        fetchpriority: 'high',
      }, {
        rel: 'preload',
        as: 'image',
        href: pillBottleWebp,
        fetchpriority: 'high',
      }, {
        rel: 'preload',
        as: 'image',
        href: scaleWebp,
        fetchpriority: 'high',
      }, {
        rel: 'preload',
        as: 'image',
        href: trafficSignWebp,
        fetchpriority: 'high',
      }
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp#webpage",
            "url": "https://www.whatthecah.com/hcp",
            "name": "Home | What the C@H? HCP Site",
            "description": "Learn about congenital adrenal hyperplasia, the science behind CAH, managing excess androgens, treating CAH, and research.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine",
              "signOrSymptom": [
                {"@type":"MedicalSymptom","name":"Early puberty"},
                {"@type":"MedicalSymptom","name":"Accelerated growth"},
                {"@type":"MedicalSymptom","name":"Fertility problem"},
                {"@type":"MedicalSymptom","name":"Height below potential"},
                {"@type":"MedicalSymptom","name":"TART"},
                {"@type":"MedicalSymptom","name":"OART"},
                {"@type":"MedicalSymptom","name":"Acne"},
                {"@type":"MedicalSymptom","name":"Hirsutism"},
                {"@type":"MedicalSymptom","name":"Mood disorders"},
                {"@type":"MedicalSymptom","name":"Adrenal crisis"},
                {"@type":"MedicalSymptom","name":"Virilization"}
              ],
              "associatedAnatomy": {
                "@type":"AnatomicalSystem",
                "name":"Adrenal glands, zona fasciculata, zona reticularis, hypothalamus, pituitary glands, endocrine, HPA axis, neuroendocrine"
              }
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          },
          {
            "@type":"VideoObject",
            "name":"Treating CAH: Then and Now",
            "description":"Treatment history and background of CAH, including look at investigational research for novel therapeutic targets",
            "duration":"PT3M4S",
            "thumbnailUrl":"https://www.whatthecah.com/assets/img/video-posters/cah-treatment-history-and-background-video.png",
            "contentUrl":"https://player.vimeo.com/progressive_redirect/playback/936707880/rendition/1080p/file.mp4?loc=external&signature=56d4619162fc4b4763bfe67ad961aee7f73989e706d979fc58f7a70d7aaac392",
            "uploadDate":"2024-10-15T00:00:00Z"
          }
        ]
      }
    ],
  }, {
    name: 'hcp-about-cah',
    path: '/hcp/about-cah',
    title: 'About CAH | What the C@H?! HCP Site',
    headerNavigationLabel: <>ABOUT CAH</>,
    sitemapNavigationLabel: <>About CAH</>,
    groupId: 1,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about congenital adrenal hyperplasia, hormonal deficiencies and excesses, the negative feedback loop, and androgen pathways.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'About CAH | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about congenital adrenal hyperplasia, hormonal deficiencies and excesses, the negative feedback loop, and androgen pathways.',
      }, {
        name: 'twitter:title',
        content: 'About CAH | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about congenital adrenal hyperplasia, hormonal deficiencies and excesses, the negative feedback loop, and androgen pathways.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/about-cah',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/about-cah',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/about-cah#webpage",
            "url": "https://www.whatthecah.com/hcp/about-cah",
            "name": "About CAH | What the C@H?! HCP Site",
            "description": "Learn about congenital adrenal hyperplasia, hormonal deficiencies and excesses, the negative feedback loop, and androgen pathways.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine"
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "About CAH",
                "item": "https://www.whatthecah.com/hcp/about-cah"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-excess-androgens-symptoms',
    path: ['/hcp/excess-androgens/symptoms', '/hcp/excess-androgens' ],
    title: 'Symptoms of Excess Androgens | What the C@H?! HCP Site',
    headerNavigationLabel: <>EXCESS<br/> ANDROGENS</>,
    headerSubNavigationLabel: <>SYMPTOMS OF EXCESS ANDROGENS</>,
    sitemapNavigationLabel: <>Excess Androgens</>,
    sitemapSubNavigationLabel: <>Symptoms of <br className="block mobile:hidden"/>Excess Androgens</>,
    groupId: 2,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about the symptoms of excess androgens, including childhood, adolescent and adult, and non-age-specific symptoms.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Symptoms of Excess Androgens | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about the symptoms of excess androgens, including childhood, adolescent and adult, and non-age-specific symptoms.',
      }, {
        name: 'twitter:title',
        content: 'Symptoms of Excess Androgens | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about the symptoms of excess androgens, including childhood, adolescent and adult, and non-age-specific symptoms.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/excess-androgens/symptoms',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/excess-androgens/symptoms',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/excess-androgens/symptoms#webpage",
            "url": "https://www.whatthecah.com/hcp/excess-androgens/symptoms",
            "name": "Symptoms of Excess Androgens | What the C@H?! HCP Site",
            "description": "Learn about the symptoms of excess androgens, including childhood, adolescent and adult, and non-age-specific symptoms.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine"
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Symptoms of Excess Androgens",
                "item": "https://www.whatthecah.com/hcp/excess-androgens/symptoms"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-excess-androgens-symptoms-in-children',
    path: '/hcp/excess-androgens/symptoms-in-children',
    title: 'Childhood-specific Symptoms | What the C@H?! HCP Site',
    headerNavigationLabel: <>EXCESS ANDROGENS</>,
    headerSubNavigationLabel: <>CHILDHOOD-SPECIFIC SYMPTOMS</>,
    sitemapNavigationLabel: <>Excess Androgens</>,
    sitemapSubNavigationLabel: <>Childhood-Specific Symptoms</>,
    groupId: 2,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about childhood-specific symptoms of excess adrenal androgens, such as early puberty and accelerated growth.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Childhood-specific Symptoms | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about childhood-specific symptoms of excess adrenal androgens, such as early puberty and accelerated growth.',
      }, {
        name: 'twitter:title',
        content: 'Childhood-specific Symptoms | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about childhood-specific symptoms of excess adrenal androgens, such as early puberty and accelerated growth.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-children',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-children',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-children#webpage",
            "url": "https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-children",
            "name": "Childhood-specific Symptoms | What the C@H?! HCP Site",
            "description": "Learn about childhood-specific symptoms of excess adrenal androgens, such as early puberty and accelerated growth.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine",
              "signOrSymptom": [
                {"@type":"MedicalSymptom","name":"Early puberty"},
                {"@type":"MedicalSymptom","name":"Accelerated growth"}
              ]
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Childhood-specific Symptoms",
                "item": "https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-children"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-excess-androgens-symptoms-in-adolescents-and-adults',
    path: '/hcp/excess-androgens/symptoms-in-adolescents-and-adults',
    title: 'Adolescent and Adult-Specific Symptoms | What the C@H?! HCP Site',
    headerNavigationLabel: <>EXCESS ANDROGENS</>,
    headerSubNavigationLabel: <>ADOLESCENT- AND ADULT-SPECIFIC SYMPTOMS</>,
    sitemapNavigationLabel: <>Excess Androgens</>,
    sitemapSubNavigationLabel: <>Adolescent- and <br className="block mobile:hidden"/>Adult-Specific Symptoms</>,
    groupId: 2,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about adolescent and adult-specific symptoms of high androgen levels, including TARTs, accelerated growth, and unmet growth potential.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Adolescent and Adult-Specific Symptoms | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about adolescent and adult-specific symptoms of high androgen levels, including TARTs, accelerated growth, and unmet growth potential.',
      }, {
        name: 'twitter:title',
        content: 'Adolescent and Adult-Specific Symptoms | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about adolescent and adult-specific symptoms of high androgen levels, including TARTs, accelerated growth, and unmet growth potential.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-adolescents-and-adults',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-adolescents-and-adults',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-adolescents-and-adults#webpage",
            "url": "https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-adolescents-and-adults",
            "name": "Adolescent and Adult-Specific Symptoms | What the C@H?! HCP Site",
            "description": "Learn about adolescent and adult-specific symptoms of high androgen levels, including TARTs, accelerated growth, and unmet growth potential.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine",
              "signOrSymptom": [
                {"@type":"MedicalSymptom","name":"TARTs"},
                {"@type":"MedicalSymptom","name":"Accelerated growth"},
                {"@type":"MedicalSymptom","name":"Unmet growth potential"}
              ]
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Adolescent and Adult-Specific Symptoms",
                "item": "https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-adolescents-and-adults"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-excess-androgens-symptoms-in-all-ages',
    path: '/hcp/excess-androgens/symptoms-in-all-ages',
    title: 'Non-age-specific Symptoms | What the C@H?! HCP Site',
    headerNavigationLabel: <>EXCESS ANDROGENS</>,
    headerSubNavigationLabel: <>NON&ndash;AGE-SPECIFIC SYMPTOMS</>,
    sitemapNavigationLabel: <>Excess Androgens</>,
    sitemapSubNavigationLabel: <>Non&ndash;Age-Specific Symptoms</>,
    groupId: 2,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Get info on symptoms of excess androgens common in children and adults, including acne, hirsutism, testicular and ovarian adrenal rest tumors.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Non-age-specific Symptoms | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Get info on symptoms of excess androgens common in children and adults, including acne, hirsutism, testicular and ovarian adrenal rest tumors.',
      }, {
        name: 'twitter:title',
        content: 'Non-age-specific Symptoms | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Get info on symptoms of excess androgens common in children and adults, including acne, hirsutism, testicular and ovarian adrenal rest tumors.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-all-ages',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-all-ages',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-all-ages#webpage",
            "url": "https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-all-ages",
            "name": "Non-age-specific Symptoms | What the C@H?! HCP Site",
            "description": "Get info on symptoms of excess androgens common in children and adults, including acne, hirsutism, testicular and ovarian adrenal rest tumors.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine",
              "signOrSymptom": [
                {"@type":"MedicalSymptom","name":"Acne"},
                {"@type":"MedicalSymptom","name":"Hirsutism"},
                {"@type":"MedicalSymptom","name":"Testicular adrenal rest tumors (TARTs)"},
                {"@type":"MedicalSymptom","name":"Ovarian adrenal rest tumors (OARTs)"}
              ]
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Non-age-specific Symptoms",
                "item": "https://www.whatthecah.com/hcp/excess-androgens/symptoms-in-all-ages"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-glucocorticoid-challenges-impact-of-high-doses',
    path: ['/hcp/glucocorticoid-challenges/impact-of-high-doses', '/hcp/glucocorticoid-challenges'],
    title: 'Impact of High-dose GCs | What the C@H?! HCP Site',
    headerNavigationLabel: <>GLUCOCORTICOID<br/> CHALLENGES</>,
    headerSubNavigationLabel: <>IMPACT OF HIGH-DOSE GC<span className="lowercase">s</span></>,
    sitemapNavigationLabel: <>GC Challenges</>,
    sitemapSubNavigationLabel: <>Impact of High-Dose GCs</>,
    groupId: 3,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about the impact of high-dose GCs, including cardiometabolic, bone, and neurological health, and infection risks when managing excess adrenal androgens.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Impact of High-dose GCs | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about the impact of high-dose GCs, including cardiometabolic, bone, and neurological health, and infection risks when managing excess adrenal androgens.',
      }, {
        name: 'twitter:title',
        content: 'Impact of High-dose GCs | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about the impact of high-dose GCs, including cardiometabolic, bone, and neurological health, and infection risks when managing excess adrenal androgens.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/glucocorticoid-challenges/impact-of-high-doses',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/glucocorticoid-challenges/impact-of-high-doses',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/impact-of-high-doses#webpage",
            "url": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/impact-of-high-doses",
            "name": "Impact of High-dose GCs | What the C@H?! HCP Site",
            "description": "Learn about the impact of high-dose GCs, including cardiometabolic, bone, and neurological health, and infection risks when managing excess adrenal androgens.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": {
              "@type": "MedicalSpecialty",
              "name": "Endocrine"
            },
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": {
                "@type": "MedicalSpecialty",
                "name": "Endocrine"
              },
              "possibleComplication": [
                "Cardiometabolic health risks",
                "Bone health issues",
                "Neurological health concerns",
                "Infection risk"
              ]
            },
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Impact of High-dose GCs",
                "item": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/impact-of-high-doses"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-glucocorticoid-challenges-cardiometabolic-health',
    path: '/hcp/glucocorticoid-challenges/cardiometabolic-health',
    title: 'Cardiometabolic Health | What the C@H?! HCP Site',
    headerNavigationLabel: <>GLOCOCORTICOID CHALLENGES</>,
    headerSubNavigationLabel: <>CARDIOMETABOLIC HEALTH</>,
    sitemapNavigationLabel: <>GC Challenges</>,
    sitemapSubNavigationLabel: <>Cardiometabolic Health</>,
    groupId: 3,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about the impact of high-dose GCs on cardiometabolic health, including comorbidities: hypertension, insulin resistance, and obesity.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Cardiometabolic Health | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about the impact of high-dose GCs on cardiometabolic health, including comorbidities: hypertension, insulin resistance, and obesity.',
      }, {
        name: 'twitter:title',
        content: 'Cardiometabolic Health | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about the impact of high-dose GCs on cardiometabolic health, including comorbidities: hypertension, insulin resistance, and obesity.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/glucocorticoid-challenges/cardiometabolic-health',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/glucocorticoid-challenges/cardiometabolic-health',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/cardiometabolic-health#webpage",
            "url": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/cardiometabolic-health",
            "name": "Cardiometabolic Health | What the C@H?! HCP Site",
            "description": "Learn about the impact of high-dose GCs on cardiometabolic health, including comorbidities: hypertension, insulin resistance, and obesity.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": {
              "@type": "MedicalSpecialty",
              "name": "Endocrine"
            },
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": {
                "@type": "MedicalSpecialty",
                "name": "Endocrine"
              },
              "possibleComplication": [
                "Hypertension",
                "Insulin resistance",
                "Obesity"
              ]
            },
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Cardiometabolic Health",
                "item": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/cardiometabolic-health"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ],
  }, {
    name: 'hcp-glucocorticoid-challenges-bone-health-and-infection-risk',
    path: '/hcp/glucocorticoid-challenges/bone-health-and-infection-risk',
    title: 'Bone Health and Infection Risk | What the C@H?! HCP Site',
    headerNavigationLabel: <>GLOCOCORTICOID CHALLENGES</>,
    headerSubNavigationLabel: <>BONE HEALTH AND INFECTION RISK</>,
    sitemapNavigationLabel: <>GC Challenges</>,
    sitemapSubNavigationLabel: <>Bone Health and Infection Risk</>,
    groupId: 3,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about the impact of high-dose GCs on bone health and infection risk, including decreased bone mineral density and increased susceptibility to infections.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Bone Health and Infection Risk | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about the impact of high-dose GCs on bone health and infection risk, including decreased bone mineral density and increased susceptibility to infections.',
      }, {
        name: 'twitter:title',
        content: 'Bone Health and Infection Risk | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about the impact of high-dose GCs on bone health and infection risk, including decreased bone mineral density and increased susceptibility to infections.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/glucocorticoid-challenges/bone-health-and-infection-risk',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/glucocorticoid-challenges/bone-health-and-infection-risk',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/bone-health-and-infection-risk#webpage",
            "url": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/bone-health-and-infection-risk",
            "name": "Bone Health and Infection Risk | What the C@H?! HCP Site",
            "description": "Learn about the impact of high-dose GCs on bone health and infection risk, including decreased bone mineral density and increased susceptibility to infections.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": {
              "@type": "MedicalSpecialty",
              "name": "Endocrine"
            },
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": {
                "@type": "MedicalSpecialty",
                "name": "Endocrine"
              },
              "possibleComplication": [
                "Decreased bone mineral density",
                "Increased fracture risk",
                "Increased susceptibility to infections"
              ]
            },
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Bone Health and Infection Risk",
                "item": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/bone-health-and-infection-risk"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }      
    ]
  }, {
    name: 'hcp-glucocorticoid-challenges-neurological-health',
    path: '/hcp/glucocorticoid-challenges/neurological-health',
    title: 'Neurological Health | What the C@H?! HCP Site',
    headerNavigationLabel: <>GLOCOCORTICOID CHALLENGES</>,
    headerSubNavigationLabel: <>NEUROLOGICAL HEALTH</>,
    sitemapNavigationLabel: <>GC Challenges</>,
    sitemapSubNavigationLabel: <>Neurological Health</>,
    groupId: 3,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about the impact of high-dose GCs on neurological health, including mood disorder risks, possible structural and functional changes, and sleep health.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Neurological Health | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about the impact of high-dose GCs on neurological health, including mood disorder risks, possible structural and functional changes, and sleep health.',
      }, {
        name: 'twitter:title',
        content: 'Neurological Health | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about the impact of high-dose GCs on neurological health, including mood disorder risks, possible structural and functional changes, and sleep health.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/glucocorticoid-challenges/neurological-health',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/glucocorticoid-challenges/neurological-health',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/neurological-health#webpage",
            "url": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/neurological-health",
            "name": "Neurological Health | What the C@H?! HCP Site",
            "description": "Learn about the impact of high-dose GCs on neurological health, including mood disorder risks, possible structural and functional changes, and sleep health.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": {
              "@type": "MedicalSpecialty",
              "name": "Endocrine"
            },
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": {
                "@type": "MedicalSpecialty",
                "name": "Endocrine"
              },
              "possibleComplication": [
                "Mood disorders",
                "Structural brain changes",
                "Functional neurological changes",
                "Sleep health issues"
              ]
            },
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Neurological Health",
                "item": "https://www.whatthecah.com/hcp/glucocorticoid-challenges/neurological-health"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-treating-cah-complications',
    path: ['/hcp/treating-cah/complications', '/hcp/treating-cah'],
    title: 'The Complications of Treating CAH | What the C@H?! HCP Site',
    headerNavigationLabel: <>TREATING CAH</>,
    headerSubNavigationLabel: <>THE COMPLICATIONS OF TREATING CAH</>,
    sitemapNavigationLabel: <>Treating CAH</>,
    sitemapSubNavigationLabel: <>The Complications of <br className="block mobile:hidden"/>Treating CAH</>,
    groupId: 4,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about the challenges of treating CAH, including prevalence of GC-related comorbidities and suboptimal androgen levels.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'The Complications of Treating CAH | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about the challenges of treating CAH, including prevalence of GC-related comorbidities and suboptimal androgen levels.',
      }, {
        name: 'twitter:title',
        content: 'The Complications of Treating CAH | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about the challenges of treating CAH, including prevalence of GC-related comorbidities and suboptimal androgen levels.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/treating-cah/complications',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/treating-cah/complications',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/treating-cah/complications#webpage",
            "url": "https://www.whatthecah.com/hcp/treating-cah/complications",
            "name": "The Complications of Treating CAH | What the C@H?! HCP Site",
            "description": "Learn about the challenges of treating CAH, including prevalence of GC-related comorbidities and suboptimal androgen levels.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": {
              "@type": "MedicalSpecialty",
              "name": "Endocrine"
            },
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": {
                "@type": "MedicalSpecialty",
                "name": "Endocrine"
              },
              "possibleComplication": [
                "GC-related comorbidities",
                "Suboptimal androgen levels"
              ]
            },
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "The Complications of Treating CAH",
                "item": "https://www.whatthecah.com/hcp/treating-cah/complications"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-treating-cah-challenges',
    path: '/hcp/treating-cah/challenges',
    title: 'Treatment Challenges | What the C@H?! HCP Site',
    headerNavigationLabel: <>TREATING CAH</>,
    headerSubNavigationLabel: <>TREATMENT CHALLENGES</>,
    sitemapNavigationLabel: <>Treating CAH</>,
    sitemapSubNavigationLabel: <>Treatment Challenges</>,
    groupId: 4,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about the challenges of treating CAH, including Endocrine Society Guidelines spanning clinical exams, radiological assessments, and lab monitoring.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Treatment Challenges | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about the challenges of treating CAH, including Endocrine Society Guidelines spanning clinical exams, radiological assessments, and lab monitoring.',
      }, {
        name: 'twitter:title',
        content: 'Treatment Challenges | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about the challenges of treating CAH, including Endocrine Society Guidelines spanning clinical exams, radiological assessments, and lab monitoring.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/treating-cah/challenges',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/treating-cah/challenges',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/treating-cah/challenges#webpage",
            "url": "https://www.whatthecah.com/hcp/treating-cah/challenges",
            "name": "Treatment Challenges | What the C@H?! HCP Site",
            "description": "Learn about the challenges of treating CAH, including Endocrine Society Guidelines spanning clinical exams, radiological assessments, and lab monitoring.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine"
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Treatment Challenges",
                "item": "https://www.whatthecah.com/hcp/treating-cah/challenges"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-treating-cah-comprehensive-care',
    path: '/hcp/treating-cah/comprehensive-care',
    title: 'Comprehensive Care | What the C@H?! HCP Site',
    headerNavigationLabel: <>TREATING CAH</>,
    headerSubNavigationLabel: <>COMPREHENSIVE CARE</>,
    sitemapNavigationLabel: <>Treating CAH</>,
    sitemapSubNavigationLabel: <>Comprehensive Care</>,
    groupId: 4,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about the comprehensive care team, including endocrinologists, mental health care providers, pediatricians, nutritionists, social workers, urologists.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Comprehensive Care | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about the comprehensive care team, including endocrinologists, mental health care providers, pediatricians, nutritionists, social workers, urologists.',
      }, {
        name: 'twitter:title',
        content: 'Comprehensive Care | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about the comprehensive care team, including endocrinologists, mental health care providers, pediatricians, nutritionists, social workers, urologists.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/treating-cah/comprehensive-care',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/treating-cah/comprehensive-care',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/treating-cah/comprehensive-care#webpage",
            "url": "https://www.whatthecah.com/hcp/treating-cah/comprehensive-care",
            "name": "Comprehensive Care | What the C@H?! HCP Site",
            "description": "Learn about the comprehensive care team, including endocrinologists, mental health care providers, pediatricians, nutritionists, social workers, urologists.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine"
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Comprehensive Care",
                "item": "https://www.whatthecah.com/hcp/treating-cah/comprehensive-care"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          },
          {
            "@type": "VideoObject",
            "name": "Patient care in CAH as an adult endocrinologist",
            "description": "Dr. Sara Lubitz, adult endocrinologist, talks about the comprehensive care needed while treating CAH",
            "duration": "PT6M53S",
            "thumbnailUrl": "https://www.whatthecah.com/assets/img/video-posters/patient-care-in-cah-as-an-adult-endrocrinologist-featuring-Dr-Lubitz.png",
            "contentUrl": "https://player.vimeo.com/progressive_redirect/playback/1000866475/rendition/1080p/file.mp4?loc=external&signature=6689410edc22f3b10b88206fe0d487a7b20f5b2a03dae993ee719f42b722cfbf",
            "uploadDate": "2024-10-15T00:00:00Z"
          }
        ]
      }      
    ],
  }, {
    name: 'hcp-treating-cah-transition-of-care',
    path: '/hcp/treating-cah/transition-of-care',
    title: 'Transition of Care | What the C@H?! HCP Site',
    headerNavigationLabel: <>TREATING CAH</>,
    headerSubNavigationLabel: <>TRANSITION OF CARE</>,
    sitemapNavigationLabel: <>Treating CAH</>,
    sitemapSubNavigationLabel: <>Transition of Care</>,
    groupId: 4,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about transitioning patients with CAH from pediatric care to adult care, including how to determine readiness.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Transition of Care | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about transitioning patients with CAH from pediatric care to adult care, including how to determine readiness.',
      }, {
        name: 'twitter:title',
        content: 'Transition of Care | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about transitioning patients with CAH from pediatric care to adult care, including how to determine readiness.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/treating-cah/transition-of-care',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/treating-cah/transition-of-care',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/treating-cah/transition-of-care#webpage",
            "url": "https://www.whatthecah.com/hcp/treating-cah/transition-of-care",
            "name": "Transition of Care | What the C@H?! HCP Site",
            "description": "Learn about transitioning patients with CAH from pediatric care to adult care, including how to determine readiness.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine"
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Transition of Care",
                "item": "https://www.whatthecah.com/hcp/treating-cah/transition-of-care"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ]
  }, {
    name: 'hcp-crf-and-crf1-receptors',
    path: '/hcp/crf-and-crf1-receptors',
    title: 'CRF and CRF1 Receptors | What the C@H?! HCP Site',
    headerNavigationLabel: <>CRF AND CRF<sub>1</sub><br/>RECEPTORS</>,
    sitemapNavigationLabel: <span className="tracking-[-0.9px] mobile:tracking-[-0.6px]-">CRF and CRF<sub>1</sub> Receptors</span>,
    groupId: 5,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Learn about the potential of the CRF pathway in CAH management.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'CRF and CRF1 Receptors | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Learn about the potential of the CRF pathway in CAH management.',
      }, {
        name: 'twitter:title',
        content: 'CRF and CRF1 Receptors | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Learn about the potential of the CRF pathway in CAH management.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/crf-and-crf1-receptors',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/crf-and-crf1-receptors',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/crf-and-crf1-receptors#webpage",
            "url": "https://www.whatthecah.com/hcp/crf-and-crf1-receptors",
            "name": "CRF and CRF1 Receptors | What the C@H?! HCP Site",
            "description": "Learn about the potential of the CRF pathway in CAH management.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": "https://health-lifesci.schema.org/Endocrine",
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": "https://health-lifesci.schema.org/Endocrine"
            }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "CRF and CRF1 Receptors",
                "item": "https://www.whatthecah.com/hcp/crf-and-crf1-receptors"
              }
            ]
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          },
          {
            "@type": "VideoObject",
            "@id": "https://www.whatthecah.com/hcp/crf-and-crf1-receptors#video",
            "name": "Treating CAH: Then and Now",
            "description": "Treatment history and background of CAH, including a look at investigational research for novel therapeutic targets.",
            "duration": "PT3M4S",
            "thumbnailUrl": "https://www.whatthecah.com/assets/img/video-posters/cah-treatment-history-and-background-video.png",
            "uploadDate": "2024-10-15T00:00:00Z",
            "embedUrl": "https://player.vimeo.com/video/936707880",
            "contentUrl": "https://player.vimeo.com/progressive_redirect/playback/936707880/rendition/1080p/file.mp4",
            "publisher": {
              "@type": "Organization",
              "@id": "https://www.neurocrine.com/#org"
            }
          }
        ]
      }
    ],
  }, {
    name: 'hcp-expert-insights',
    path: '/hcp/expert-insights',
    title: 'Expert Insights | What the C@H?! HCP Site',
    headerNavigationLabel: <>EXPERT<br/>INSIGHTS</>,
    sitemapNavigationLabel: <>Expert Insights</>,
    groupId: 6,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Watch videos featuring pediatric and adult endocrinologists speaking about their experience with CAH.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Expert Insights | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Watch videos featuring pediatric and adult endocrinologists speaking about their experience with CAH.',
      }, {
        name: 'twitter:title',
        content: 'Expert Insights | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Watch videos featuring pediatric and adult endocrinologists speaking about their experience with CAH.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/expert-insights',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/expert-insights',
      },
    ],
    schemaTag: [
      {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "MedicalWebPage",
            "@id": "https://www.whatthecah.com/hcp/expert-insights#webpage",
            "url": "https://www.whatthecah.com/hcp/expert-insights",
            "name": "Expert Insights | What the C@H?! HCP Site",
            "description": "Watch videos featuring pediatric and adult endocrinologists speaking about their experience with CAH.",
            "isPartOf": {
              "@type": "WebSite",
              "name": "What the C@H?! HCP Site",
              "alternateName": "What the CAH HCP Site",
              "url": "https://www.whatthecah.com/hcp"
            },
            "audience": {
              "@type": "MedicalAudience",
              "audienceType": "HealthcareProvider"
            },
            "specialty": {
              "@type": "MedicalSpecialty",
              "name": "Endocrine"
            },
            "about": {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "alternateName": "CAH",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/",
              "relevantSpecialty": {
                "@type": "MedicalSpecialty",
                "name": "Endocrine"
              }
            },
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://www.whatthecah.com/hcp"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Expert Insights",
                "item": "https://www.whatthecah.com/hcp/expert-insights"
              }
            ]
          },
          {
            "@type": "ItemList",
            "@id": "https://www.whatthecah.com/hcp/expert-insights#video-list",
            "name": "Expert Insights Video Series",
            "itemListOrder": "http://schema.org/ItemListOrderAscending",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "item": { "@id": "https://www.whatthecah.com/hcp/expert-insights#video1" } },
              { "@type": "ListItem", "position": 2, "item": { "@id": "https://www.whatthecah.com/hcp/expert-insights#video2" } },
              { "@type": "ListItem", "position": 3, "item": { "@id": "https://www.whatthecah.com/hcp/expert-insights#video3" } },
              { "@type": "ListItem", "position": 4, "item": { "@id": "https://www.whatthecah.com/hcp/expert-insights#video4" } }
            ]
          },
          {
            "@type": "VideoObject",
            "@id": "https://www.whatthecah.com/hcp/expert-insights#video1",
            "name": "Balancing Excess Androgens and Glucocorticoids as a Pediatric Endocrinologist",
            "description": "Dr. Ahmed Khattab discusses balancing androgen and glucocorticoid levels in CAH care.",
            "thumbnailUrl": "https://www.whatthecah.com/static/media/balancing-excess-androgens-and-glucocorticoids-as-a-pediatric-endocrinologist-featuring-dr-khattab.7514c0748eeb7ca72719.png",
            "embedUrl": "https://player.vimeo.com/video/1014940961",
            "uploadDate": "2024-10-15T00:00:00Z",
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "VideoObject",
            "@id": "https://www.whatthecah.com/hcp/expert-insights#video2",
            "name": "Patient Care in CAH as an Adult Endocrinologist",
            "description": "Dr. Sara Lubitz explains challenges and considerations in adult CAH management.",
            "thumbnailUrl": "https://www.whatthecah.com/static/media/patient-care-in-cah-as-an-adult-endrocrinologist-featuring-Dr-Lubitz.a8e28d4719410f468103.png",
            "embedUrl": "https://player.vimeo.com/video/1000866475",
            "uploadDate": "2024-10-15T00:00:00Z",
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "VideoObject",
            "@id": "https://www.whatthecah.com/hcp/expert-insights#video3",
            "name": "Managing CAH Throughout Childhood and Adolescence",
            "description": "Dr. Ahmed Khattab reviews the importance of interdisciplinary care and transition planning for pediatric and adolescent CAH patients.",
            "thumbnailUrl": "https://www.whatthecah.com/static/media/managing-cah-throughout-childhood-and-adolescence-featuring-dr-khattab.f3735f366f4342b9b0fa.png",
            "embedUrl": "https://player.vimeo.com/video/1004204575",
            "uploadDate": "2024-10-15T00:00:00Z",
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "VideoObject",
            "@id": "https://www.whatthecah.com/hcp/expert-insights#video4",
            "name": "Establishing New Patients with Congenital Adrenal Hyperplasia",
            "description": "Dr. Sara Lubitz highlights approaches to initiating care and building long-term patient relationships in CAH.",
            "thumbnailUrl": "https://www.whatthecah.com/static/media/establishing-new-patients-featuring-dr-lubitz.50492074cd9aa90a28d6.png",
            "embedUrl": "https://player.vimeo.com/video/1004204890",
            "uploadDate": "2024-10-15T00:00:00Z",
            "publisher": { "@id": "https://www.neurocrine.com/#org" }
          },
          {
            "@type": "Organization",
            "@id": "https://www.neurocrine.com/#org",
            "name": "Neurocrine Biosciences, Inc.",
            "url": "https://www.neurocrine.com/"
          }
        ]
      }
    ],
  }, {
    name: 'hcp-keep-in-touch',
    path: ['/hcp/keep-in-touch', '/hcp/keep-in-touch/:confirmation'],
    title: 'Keep in Touch | What the C@H?! HCP Site',
    sitemapNavigationLabel: <>Keep in Touch</>,
    groupId: 7,
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Sign up to join the What the C@H?! community and receive resources, including videos from expert CAH practitioners.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Keep in Touch | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Sign up to join the What the C@H?! community and receive resources, including videos from expert CAH practitioners.',
      }, {
        name: 'twitter:title',
        content: 'Keep in Touch | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Sign up to join the What the C@H?! community and receive resources, including videos from expert CAH practitioners.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/keep-in-touch',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/keep-in-touch',
      },
    ],
  }, {
    name: 'hcp-site-map',
    path: '/hcp/site-map',
    title: 'Site Map | What the C@H?! HCP Site',
    metadata: [
      {
        name: 'type',
        content: 'website'
      }, {
        name: 'description',
        content: 'Site map.',
      }, {
        property: 'og:type',
        content: 'Website',
      }, {
        property: 'og:site_name',
        content: 'What the C@H?! HCP Site',
      }, {
        property: 'og:title',
        content: 'Site Map | What the C@H?! HCP Site',
      }, {
        property: 'og:image',
        content: 'https://www.whatthecah.com/assets/img/logos/hcp-logo.png',
      }, {
        property: 'og:description',
        content: 'Site map.',
      }, {
        name: 'twitter:title',
        content: 'Site Map | What the C@H?! HCP Site',
      }, {
        name: 'twitter:description',
        content: 'Site map.',
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/site-map',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/site-map',
      },
    ],
  }, {
    name: 'hcp-error-404',
    path: '/hcp/*',
    title: '404 error page',
    // metadata: [
    //   {
    //     name: 'description',
    //     content: ''
    //   }
    // ],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.whatthecah.com/hcp/404-not-found',
      }, {
        rel: 'alternate',
        hreflang: 'en-us',
        href: 'https://www.whatthecah.com/hcp/404-not-found',
      },
    ],
  }
];


const hcpHeaderNavigationItems = hcpPageData.filter((page) => page.headerNavigationLabel !== undefined).map((page) => {
  return {
    groupId: page.groupId,
    name: page.headerNavigationLabel,
    subName: page.headerSubNavigationLabel,
    path: page.path,
  }
});

const hcpSitemapNavigationItems = hcpPageData.filter((page) => page.sitemapNavigationLabel !== undefined).map((page) => { 
  return {
    groupId: page.groupId,
    name: page.sitemapNavigationLabel,
    subName: page.sitemapSubNavigationLabel,
    path: page.path,
  }
});

export {hcpPageData as default, hcpHeaderNavigationItems, hcpSitemapNavigationItems};